<template>
    <div class="session-update-wrapper">
        <a-modal
            class="session-update"
            :visible="visible"
            :title="$t('program.batch_edit' /* 批量编辑 */)"
            :width="600"
            :maskClosable="false"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
        >
            <a-form :form="form">
                <a-form-item :hidden="true">
                    <a-input v-decorator="['sid']"></a-input>
                </a-form-item>
                <a-form-item :label="$t('program.batch_live_label_hall' /* 会场 */)" :help="$t('program.no_select_not_update' /* 不选择表示不做更新 */)">
                    <a-select placeholder="请选择会场" v-decorator="['hall_id']" allowClear>
                        <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">
                            {{ item.meeting_hall }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('program.batch_live_label_date' /* 日期 */)" :help="$t('program.no_select_not_update' /* 不选择表示不做更新 */)">
                    <a-select :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date')" v-decorator="['date_id']" allowClear>
                        <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">
                            {{ item.meeting_date }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item :label="$t('program.cn_website_display_mode' /* 中文网站显示方式 */)">
                    <a-radio-group name="display_cnmode" v-decorator="['display_cnmode']">
                        <a-radio :value="0">{{ $t('web.default_text' /* 默认 */) }}</a-radio>
                        <a-radio :value="1">{{ $t('web.en' /* 英文 */) }}</a-radio>
                        <a-radio :value="2">{{ $t('web.cn_en' /* 中英文 */) }}</a-radio>
                        <a-radio :value="3">{{ $t('web.cn' /* 中文 */) }}</a-radio>
                        <a-radio :value="-1">{{ $t('web.no_show' /* 不显示 */) }}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="$t('program.en_website_display_mode' /* 英文网站显示方式 */)">
                    <a-radio-group name="display_enmode" v-decorator="['display_enmode']">
                        <a-radio :value="0">{{ $t('web.default_text' /* 默认 */) }}</a-radio>
                        <a-radio :value="-1">{{ $t('web.no_show' /* 不显示 */) }}</a-radio>
                    </a-radio-group>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
import pick from 'lodash.pick';

export default {
    name: 'BatchSessionUpdateModal',
    props: {
        dateList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        hallList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this)
        };
    },
    methods: {
        show(ids) {
            this.visible = true;
            this.$nextTick(() => {
                this.form.setFieldsValue({ sid: ids });
            });
        },
        handleOk() {
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.confirmLoading = true;
                    this.$request
                        .post({ url: 'batchSessionEdit', data: values })
                        .then(res => {
                            this.$message.success(res.message);
                            this.confirmLoading = false;
                            this.handleCancel();
                            this.$emit('closeSessionUpdate');
                        })
                        .finally(() => {
                            this.confirmLoading = false;
                        });
                }
            });
        },
        handleCancel() {
            this.form.resetFields();
            this.visible = false;
        }
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-form-explain {
    color: #f00;
}
</style>